// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1Z4nF","actions":"GroupTable_actions__2MDux","deleteModalFooter":"GroupTable_deleteModalFooter__2B0KO"};